import {GET_CRL_REASONS} from "../types";
import crlReasons from "../language/crlReasons";

export default () => async (dispatch,getState) =>
{
    dispatch({type: GET_CRL_REASONS, payload: {crlReasons:crlReasons[getState().auth.language]}});
};